interface Page {
  pageSize: number;
  pageNumber: number;
}

export interface PageableReponse<T> {
  pageable: Page;
  totalElements: number;
  content: T[];
}

export interface Filter {
  key: string;
  operateur: string;
  value?: string | number | Date;
  valueMin?: number | Date;
  valueMax?: number | Date;
  valueIn?: string[];
}

export interface SortPayload {
  key: string;
  direction: SortDirections;
}

export type FiltersPayloads = Filter[];

export interface PayloadWithPageAndFilter {
  page: number;
  size: number;
  filtres: FiltersPayloads;
  tri: SortPayload;
}

export enum SortDirectionsEnum {
  ASCENDING = "ASCENDING",
  DESCENDING = "DESCENDING",
}

export type SortDirections = SortDirectionsEnum;
